<template>
  <!--  <div>ssss</div>-->
  <div>
    <top-header></top-header>
    <div class="search_container">
      <div style="padding-top: 30px;padding-left: 30px">
        <span style="padding-right: 20px">搜索</span>
        <el-input v-model="searchValue" placeholder="请输入搜索内容" style="width: 200px; padding-right: 20px"/>
        <el-button type="primary" style="padding-left: 20px" @click="searchBtnClick">搜索</el-button>
      </div>
    </div>
    <el-button
      type="primary"
      icon="el-icon-plus" style="margin-top: 10px;margin-left: 20px"
      @click="handleAddStudent">添加学生</el-button>
    <el-button
      type="primary"
      icon="el-icon-plus" style="margin-top: 10px;margin-left: 20px"
      @click="handleBatchImportStudent">批量导入</el-button>
    <div class="table_container">
      <el-table
        :data="dataList"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width: 100%">
        <el-table-column
          label="姓名"
          prop="Name">
        </el-table-column>
        <el-table-column
          label="联系方式"
          prop="Mobile">
        </el-table-column>
<!--        <el-table-column-->
<!--          label="状态">-->
<!--          <template slot-scope="props">-->
<!--            <p> {{ props.row.Status === 0 ? '禁用' : '正常' }}</p>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          label="更新时间">
          <template slot-scope="props">
            <p> {{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.UpdateTime) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleStudentInfo(scope.$index, scope.row)">查看</el-button>
            <el-button
              size="mini"
              @click="handleModifyStudent(scope.$index, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="handleDeleteStudent(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="添加学生" :visible.sync="dialogAddStudentVisible">
      <el-form :model="addStudentModel">
        <el-form-item label="姓名" label-width="100px">
          <el-input v-model="addStudentModel.Name"></el-input>
        </el-form-item>
        <el-form-item label="密码" label-width="100px">
          <el-input v-model="addStudentModel.Passwd"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="100px">
          <el-input v-model="addStudentModel.Mobile"></el-input>
        </el-form-item>
        <el-form-item label="昵称" label-width="100px">
          <el-input v-model="addStudentModel.Nick"></el-input>
        </el-form-item>
      </el-form>
      <div style="padding-top: 10px;padding-left: 30px">
        <el-button @click="dialogAddStudentVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStudentOkBtnClick">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑学生" :visible.sync="dialogModifyStudentVisible">
      <el-form :model="modifyStudentModel">
        <el-form-item label="姓名" label-width="100px">
          <el-input v-model="modifyStudentModel.Name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="100px">
          <el-input v-model="modifyStudentModel.Mobile"></el-input>
        </el-form-item>
      </el-form>
      <div style="padding-top: 10px;padding-left: 30px">
        <el-button @click="dialogModifyStudentVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyStudentOkBtnClick">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="dialogBatchImportStudentVisible" @close="batchImportStuDialogClose">
      <el-upload
        ref="upload"
        action="/"
        :show-file-list="false"
        :on-change="importExcel"
        :auto-upload="false" style="padding-bottom: 20px">
        <el-button
          slot="trigger"
          icon="el-icon-upload"
          size="small"
          type="primary">
          上传文件
        </el-button>
      </el-upload>
      <el-table
        :data="importData" v-loading="uploadLoading"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width: 100%;" height="600">
        <el-table-column
          label="姓名">
          <template slot-scope="props">
            <el-input v-model="props.row.Name" v-if="props.row.canEdit"></el-input>
            <span v-else>{{props.row.Name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="密码">
          <template slot-scope="props">
            <el-input v-model="props.row.Passwd" v-if="props.row.canEdit"></el-input>
            <span v-else>{{props.row.Passwd}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号">
          <template slot-scope="props">
            <el-input v-model="props.row.Mobile" v-if="props.row.canEdit"></el-input>
            <span v-else>{{props.row.Mobile}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="备注">
          <template slot-scope="props">
            <el-input v-model="props.row.Remark" v-if="props.row.canEdit"></el-input>
            <span v-else>{{props.row.Remark}}</span>
          </template>
        </el-table-column>
        <el-table-column width="300"
          label="操作">
          <template slot-scope="props">
            <div>
              <el-button
                size="mini" v-if="props.row.Isupload === undefined || props.row.Isupload === 0 || props.row.Isupload === 2"
                @click="handleEditBatchImportStudent(props.row)">{{props.row.canEdit === true ? '完成' : '编辑'}}</el-button>
              <div v-if="props.row.Isupload === 1" class="el-icon-success" style="color: #13ce66;"><span>导入成功</span></div>
              <div v-if="props.row.Isupload === 2" class="el-icon-error" style="color: #FF0000;"><span>{{props.row.errorMsg}}</span></div>
            </div>

          </template>
        </el-table-column>
      </el-table>
      <div style="padding-top: 10px;padding-left: 30px">
        <el-button @click="dialogBatchImportStudentVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchImportStudentOkBtnClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopHeader from '../../components/TopHeader'
import XLSX from 'xlsx'
export default {
  name: 'StuManager',
  components: {TopHeader},
  data () {
    return {
      dataList: [],
      currentPage: 1,
      pageCount: 10,
      totalCount: 0,
      dialogAddStudentVisible: false,
      dialogModifyStudentVisible: false,
      addStudentModel: {},
      modifyStudentModel: {},
      tempIndex: 0,
      searchValue: '',
      dialogBatchImportStudentVisible: false,
      importData: [],
      uploadLoading: false,
      uploadIndex: 0
    }
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/studentop') {
          console.log('----', route.path)
          that.getStudentList()
        }
      },
      deep: true
    }
  },
  created () {
    this.getStudentList()
  },
  methods: {
    batchImportStudentOkBtnClick () {
      this.uploadLoading = true
      this.addStudent()
    },
    addStudent () {
      if (this.uploadIndex >= this.importData.length) {
        this.uploadLoading = false
        this.uploadIndex = 0
        return
      }
      let item = this.importData[this.uploadIndex]
      if (item.Isupload === 1) {
        this.uploadIndex++
        this.addStudent()
      } else {
        let requestData = {name: item.Name.toString(), mobile: item.Mobile.toString(), passwd: item.Passwd.toString(), nick: item.Remark.toString()}
        this.$api.userManager.addStudent(requestData).then((res) => {
          if (res.code === 0) {
            item.Isupload = 1
            this.uploadIndex++
            this.reloadItem(item)
            this.addStudent()
          } else {
            item.Isupload = 2
            item.errorMsg = res.msg
            this.uploadIndex++
            this.reloadItem(item)
            this.addStudent()
          }
        })
      }
    },
    handleEditBatchImportStudent (row) {
      if (row.canEdit === false) {
        this.checkAllImportDataNoEdit()
        row.canEdit = true
        this.reloadItem(row)
      } else {
        this.checkAllImportDataNoEdit()
        this.reloadItem(row)
      }
    },
    reloadItem (item) {
      item.Name = item.Name + ' '
      item.Name = item.Name.replace(/(^\s*)|(\s*$)/g, '')
    },
    importExcel (file) {
      const types = file.name.split('.')[1]
      const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
      if (!fileType) {
        alert('格式错误！请重新选择')
        return
      }
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          let tabItem = tabJson[0]
          if (tabItem.sheet && tabItem.sheet.length > 0) {
            tabItem.sheet.splice(0, 1)
            if (tabItem.sheet.length > 50) {
              this.importData = tabItem.sheet.slice(0, 50)
            } else {
              this.importData = tabItem.sheet
            }
            this.checkAllImportDataNoEdit()
          }
        }
      })
    },
    checkAllImportDataNoEdit () {
      for (let i = 0; i < this.importData.length; i++) {
        let item = this.importData[i]
        item.canEdit = false
      }
    },
    file2Xce (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        reader.onload = function (e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        reader.readAsBinaryString(file.raw)
        // reader.readAsBinaryString(file) // 传统input方法
      })
    },
    batchImportStuDialogClose () {
      this.importData = []
      this.uploadLoading = false
      this.uploadIndex = 0
    },
    handleBatchImportStudent () {
      this.$api.home.interCheck().then((res) => {

      })
      this.dialogBatchImportStudentVisible = true
    },
    getStudentList () {
      if (this.searchValue === '') {
        let requestData = {count: this.pageCount, page: this.currentPage}
        this.$api.userManager.getStudentList(requestData).then((res) => {
          if (res.code === 0) {
            this.dataList = res.data
            this.totalCount = res.count
          }
        })
      } else {
        let requestData = {count: this.pageCount, page: this.currentPage, key: this.searchValue}
        this.$api.userManager.searchStudent(requestData).then((res) => {
          if (res.code === 0) {
            this.dataList = res.data
            this.totalCount = res.count
          }
        })
      }
    },
    searchBtnClick () {
      this.currentPage = 1
      this.getStudentList()
    },
    handleSizeChange (val) {
      this.pageCount = val
      this.currentPage = 1
      this.getStudentList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getStudentList()
    },
    handleAddStudent () {
      this.$api.home.interCheck().then((res) => {

      })
      this.dialogAddStudentVisible = true
    },
    addStudentOkBtnClick () {
      let requestData = {name: this.addStudentModel.Name, mobile: this.addStudentModel.Mobile, passwd: this.addStudentModel.Passwd, nick: this.addStudentModel.Nick}
      this.$api.userManager.addStudent(requestData).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.addStudentModel = {}
          this.getStudentList()
          this.dialogAddStudentVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleStudentInfo (index, row) {
      this.$router.push({path: '/studentInfo', query: {mobile: row.Mobile}})
    },
    handleModifyStudent (index, row) {
      this.$api.home.interCheck().then((res) => {

      })
      this.dialogModifyStudentVisible = true
      this.modifyStudentModel = row
    },
    modifyStudentOkBtnClick () {
      let requestData = {id: this.modifyStudentModel.Id, mobile: this.modifyStudentModel.Mobile, name: this.modifyStudentModel.Name}
      this.$api.userManager.modifyStudent(requestData).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.getStudentList()
          this.dialogModifyStudentVisible = false
        }
      })
    },
    handleDeleteStudent (index, row) {
      let alertStr = '确定要删除学生   "' + row.Name + '"   吗？'
      this.$confirm(alertStr, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {id: row.Id}
        this.$api.userManager.delStudent(requestData).then((res) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getStudentList()
          }
        })
      }).catch(() => {

      })
    },
    formatDate (fmt, dateStr) {
      let date = new Date(dateStr)
      let ret
      let opt = {
        'Y+': date.getFullYear().toString(),
        'm+': (date.getMonth() + 1).toString(),
        'd+': date.getDate().toString(),
        'H+': date.getHours().toString(),
        'M+': date.getMinutes().toString(),
        'S+': date.getSeconds().toString()
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
      };
      return fmt
    },
    addTestData () {
      if (this.tempIndex > 1000000)
      {
        return
      }
      this.tempIndex++
      let key = this.$route.query.key
      let name = key + this.tempIndex
      let requestData = {name: name, mobile: name, passwd: name, userop: "{}", nick: name}
      this.$api.userManager.addStudent(requestData).then((res) => {
        if (res.code === 0) {
          this.addTestData()
        }
      })
    }
  }
}
</script>

<style scoped>
  .search_container{
    margin: 20px;
    height: 100px;
    background-color: #EFF1F6;
  }
  .table_container{
    padding: 20px;
  }
  .Pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/userManager/StuManager.vue